export const DEFAULT_DOMAIN = 'wt.ls'
export const FREE_LIMIT = 500
export const FREE_PROJECTS = 3
export const FREE_SENDS = 5000
export const DEFAULT_LEGAL =
	'Spinoff Studio GbR, Charlottenstraße 1, 10969 Berlin'

export const DEFAULT_ICON = '/img/wt.png'
export const DEFAULT_FAVICON = '/img/wt.png'
export const DEFAULT_OGIMAGE = '/img/placeholder/open-graph-image.png'

export const DEFAULT_LIST_ID = 'default_list_id'

export const TEMPLATES = {
	SYSTEM: {
		EMAIL_WELCOME_TO_WAITLESS: 'system_welcome_to_waitless',
		EMAIL_FORGOT_PASSWORD: 'system_forgot_password_email',
		EMAIL_VERIFY: 'system_verify_email',
		EMAIL_CHANGE: 'system_change_email',
		EMAIL_FIRST_LIST: 'system_first_list',
		EMAIL_WELCOME_TO_PRO: 'system_welcome_to_pro',
		EMAIL_WARNING_UPGRADE: 'system_upgrade_to_pro',
		EMAIL_RESCUE: 'system_rescue_email',
		EMAIL_DELETION_REQUEST: 'system_deletion_request',
		EMAIL_WHITELIST: 'system_whitelist_request',
	},
	JOURNEYS: [
		{
			id: 'productlaunch',
			name: 'Viral product launch',
			status: 'active',
			icon: 'Rocket',
			description: 'Simple waitlist with referrals',
			PAGE_SIGNUP: 'journey_productlaunch_page_signup',
			PAGE_SUCCESS: 'journey_productlaunch_page_success',
			PAGE_SUBSCRIBER: 'journey_productlaunch_page_subscriber',
			PAGE_REFERRAL: 'journey_productlaunch_page_referral',
			EMAIL_VERIFICATION: 'journey_productlaunch_email_verification',
			EMAIL_INVITATION: 'journey_productlaunch_email_invitation',
			EMAIL_REDEEMED_INVITATION:
				'journey_productlaunch_email_redeemed_invitation',
		},
		{
			id: 'gamification',
			name: 'Product gamification',
			status: 'soon',
			icon: 'Gamepad',
			description: 'Gamify your entire product through actions.',
			PAGE_SIGNUP: 'journey_gamification_page_signup',
			PAGE_SUCCESS: 'journey_gamification_page_success',
			PAGE_SUBSCRIBER: 'journey_gamification_page_subscriber',
			PAGE_REFERRAL: 'journey_gamification_page_referral',
			EMAIL_VERIFICATION: 'journey_gamification_email_verification',
			EMAIL_INVITATION: 'journey_gamification_email_invitation',
			EMAIL_REDEEMED_INVITATION:
				'journey_gamification_email_redeemed_invitation',
		},
		{
			id: 'truefans',
			name: 'Find your true fans',
			status: 'soon',
			icon: 'Users',
			description: 'Find your true fans through actions.',
			PAGE_SIGNUP: 'journey_truefans_page_signup',
			PAGE_SUCCESS: 'journey_truefans_page_success',
			PAGE_SUBSCRIBER: 'journey_truefans_page_subscriber',
			PAGE_REFERRAL: 'journey_truefans_page_referral',
			EMAIL_VERIFICATION: 'journey_truefans_email_verification',
			EMAIL_INVITATION: 'journey_truefans_email_invitation',
			EMAIL_REDEEMED_INVITATION: 'journey_truefans_email_redeemed_invitation',
		},
		{
			id: 'newsletter',
			name: 'Ranked newsletter',
			status: 'soon',
			icon: 'Mail',
			description:
				'A simple newsletter where people are ranked through actions.',
			PAGE_SIGNUP: 'journey_newsletter_page_signup',
			PAGE_SUCCESS: 'journey_newsletter_page_success',
			PAGE_SUBSCRIBER: 'journey_newsletter_page_subscriber',
			PAGE_REFERRAL: 'journey_newsletter_page_referral',
			EMAIL_VERIFICATION: 'journey_newsletter_email_verification',
			EMAIL_INVITATION: 'journey_newsletter_email_invitation',
			EMAIL_REDEEMED_INVITATION: 'journey_newsletter_email_redeemed_invitation',
		},
	],
	CAMPAIGNS: {
		CAMPAIGN_INVITE_TOP_100: 'campaigns_invite_top_100',
		CAMPAIGN_BETA_LAUNCH: 'campaigns_beta_launch',
		CAMPAIGN_WEEKLY_LOG: 'campaigns_weekly_log',
		CAMPAIGN_PRODUCT_UPDATE: 'campaigns_product_update',
		CAMPAIGN_CUSTOMER_FEEDBACK: 'campaigns_customer_feedback',
		CAMPAIGN_REFERRAL_PROGRAM: 'campaigns_referral_program',
		CAMPAIGN_ABANDONED_CART: 'campaigns_abandoned_cart',
		CAMPAIGN_WEBINAR_SERIES: 'campaigns_webinar_series',
		CAMPAIGN_NEW_FEATURE_ANNOUNCEMENT: 'campaigns_new_feature_announcement',
		CAMPAIGN_LOYALTY_REWARDS: 'campaigns_loyalty_rewards',
	},
	THEMES: [
		{
			id: 'themes_monochrome_elegance',
			name: 'Monochrome Elegance',
			color: '#FFFFFF',
			backgroundColor: '#FFFFFF',
			borderColor: '#F4F4F4',
			accentColor: '#000000',
			buttonTextColor: '#FFFFFF',
			headingColor: '#000000',
			paragraphColor: '#333333',
			inputTextColor: '#333333',
			headingFont: 'Uncut Sans',
			paragraphFont: 'IBM Plex Sans',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_inverse_contrast',
			name: 'Inverse Contrast',
			color: '#000000',
			backgroundColor: '#000000',
			borderColor: '#F4F4F4',
			accentColor: '#FFFFFF',
			buttonTextColor: '#000000',
			headingColor: '#FFFFFF',
			paragraphColor: '#CCCCCC',
			inputTextColor: '#CCCCCC',
			headingFont: 'Roboto',
			paragraphFont: 'Open Sans',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_light_mode',
			name: 'Light Mode',
			color: '#FAFAFA',
			backgroundColor: '#FAFAFA',
			borderColor: '#F4F4F4',
			accentColor: '#6200EE',
			buttonTextColor: '#FFFFFF',
			headingColor: '#212121',
			paragraphColor: '#757575',
			inputTextColor: '#757575',
			headingFont: 'Montserrat',
			paragraphFont: 'Lato',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_sunset_glow',
			name: 'Sunset Glow',
			color: '#FFF3E0',
			backgroundColor: '#FFF3E0',
			borderColor: '#F4F4F4',
			accentColor: '#FF5722',
			buttonTextColor: '#FFFFFF',
			headingColor: '#BF360C',
			paragraphColor: '#E64A19',
			inputTextColor: '#E64A19',
			headingFont: 'Poppins',
			paragraphFont: 'Roboto',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_forest_mist',
			name: 'Forest Mist',
			color: '#E8F5E9',
			backgroundColor: '#E8F5E9',
			borderColor: '#F4F4F4',
			accentColor: '#4CAF50',
			buttonTextColor: '#FFFFFF',
			headingColor: '#1B5E20',
			paragraphColor: '#2E7D32',
			inputTextColor: '#2E7D32',
			headingFont: 'Playfair Display',
			paragraphFont: 'Raleway',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_urban_chic',
			name: 'Urban Chic',
			color: '#ECEFF1',
			backgroundColor: '#ECEFF1',
			borderColor: '#F4F4F4',
			accentColor: '#607D8B',
			buttonTextColor: '#FFFFFF',
			headingColor: '#263238',
			paragraphColor: '#455A64',
			inputTextColor: '#455A64',
			headingFont: 'Inter',
			paragraphFont: 'Open Sans',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_dark_mode',
			name: 'Dark Mode',
			color: '#121212',
			backgroundColor: '#121212',
			borderColor: '#F4F4F4',
			accentColor: '#BB86FC',
			buttonTextColor: '#000000',
			headingColor: '#FFFFFF',
			paragraphColor: '#E0E0E0',
			inputTextColor: '#E0E0E0',
			headingFont: 'Inter',
			paragraphFont: 'Lato',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_lavender_dreams',
			name: 'Lavender Dreams',
			color: '#F3E5F5',
			backgroundColor: '#F3E5F5',
			borderColor: '#F4F4F4',
			accentColor: '#9C27B0',
			buttonTextColor: '#FFFFFF',
			headingColor: '#4A148C',
			paragraphColor: '#6A1B9A',
			inputTextColor: '#6A1B9A',
			headingFont: 'Oswald',
			paragraphFont: 'Roboto',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
		{
			id: 'themes_golden_sands',
			name: 'Golden Sands',
			color: '#FFF8E1',
			backgroundColor: '#FFF8E1',
			borderColor: '#F4F4F4',
			accentColor: '#FFC107',
			buttonTextColor: '#FFFFFF',
			headingColor: '#FF6F00',
			paragraphColor: '#FF8F00',
			inputTextColor: '#FF8F00',
			headingFont: 'Roboto',
			paragraphFont: 'Poppins',
			backgroundInputColor: '#FFFFFF',
			radius: 12,
		},
	],
}

export const DEFAULT_THEME = {
	color: '#FFF8E1',
	backgroundColor: '#FFF8E1',
	accentColor: '#FFC107',
	buttonTextColor: '#000000',
	headingColor: '#FF6F00',
	paragraphColor: '#FF8F00',
	headingFont: 'Raleway',
	paragraphFont: 'Poppins',
}

export const TRIGGERS = {
	NEW_SIGNUP: 'new_signup_trigger',
	NEW_INVITATION: 'new_invite_trigger',
	REDEEMED_INVITE: 'redeemed_invite',
}

export const PAGE_TEMPLATES = {
	JOURNEY: {
		SIGNUP_PAGE: 'confirmation_email',
		INVITATION_EMAIL: 'invitation_email',
		REDEEMED_INVITE_EMAIL: 'redeemed_invite_email',
	},
}

export const SIGNUP_PAGE = 'Signup page'
export const SUCCESS_PAGE = 'Success page'
export const REFERRAL_PAGE = 'Referral page'

export const EMAIL_STYLES = {
	BUTTON_LINK:
		'border-radius: {{radius}}; color: {{buttonTextColor}}; background-color: {{accentColor}}; height: 45px; padding-left: 16px; padding-right: 16px; display: flex; border: none; outline: none;width: fit-content;',
}

export const IDEAS = [
	{ name: 'Tutch', pitch: 'The real social network.' },
	{ name: 'EcoSwap', pitch: 'Marketplace for trading sustainable products.' },
	{ name: 'MindMeld', pitch: 'AI-powered collaborative brainstorming tool.' },
	{ name: 'NanoChef', pitch: 'Molecular gastronomy kit for home cooks.' },
	{ name: 'SkyGarden', pitch: 'Drone-managed urban rooftop farms.' },
	{ name: 'WaveWallet', pitch: 'Cryptocurrency for ocean conservation.' },
	{ name: 'QuantumLeap', pitch: 'Quantum computing education platform.' },
	{ name: 'BioSync', pitch: 'Wearable tech for optimizing circadian rhythms.' },
	{ name: 'VirtuPet', pitch: 'AR pet companions for the elderly.' },
	{ name: 'EcoTrack', pitch: 'Personal carbon footprint monitoring app.' },
	{ name: 'NeuroPlay', pitch: 'Brain-computer interface for gaming.' },
	{ name: 'SolarSail', pitch: 'Inflatable solar sails for small satellites.' },
	{ name: 'GenomeGuard', pitch: 'DNA-based cybersecurity solutions.' },
	{ name: 'HoloTeach', pitch: 'Holographic lectures for remote learning.' },
	{ name: 'AquaLens', pitch: 'Contact lenses that filter blue light.' },
	{
		name: 'FoodPrint',
		pitch: 'Blockchain for transparent food supply chains.',
	},
	{ name: 'MicroMend', pitch: 'Nanobot-assisted microsurgery tools.' },
	{ name: 'EmoAI', pitch: 'Emotion recognition AI for customer service.' },
	{ name: 'GreenPrint', pitch: '3D-printed sustainable housing solutions.' },
	{ name: 'SoundScape', pitch: 'Personalized ambient soundscapes for focus.' },
	{
		name: 'BioFabric',
		pitch: 'Self-repairing textiles using living organisms.',
	},
	{ name: 'MemoryBank', pitch: 'Secure cloud storage for digitized memories.' },
	{
		name: 'AstroFarm',
		pitch: 'Modular hydroponic systems for space colonies.',
	},
	{ name: 'NeuroPace', pitch: 'AI coach for mindfulness and meditation.' },
	{
		name: 'HapticHarmony',
		pitch: 'Wearable tech for long-distance relationships.',
	},
	{
		name: 'EcoPackage',
		pitch: 'Edible and biodegradable packaging solutions.',
	},
	{
		name: 'DreamDecode',
		pitch: 'AI-powered dream analysis and visualization.',
	},
	{ name: 'QuanTrade', pitch: 'Quantum algorithm-based trading platform.' },
	{
		name: 'BioLight',
		pitch: 'Bioluminescent plants for sustainable lighting.',
	},
	{ name: 'VirtualVet', pitch: 'AI-powered veterinary diagnostics app.' },
	{ name: 'OceanClean', pitch: 'Autonomous drones for ocean plastic cleanup.' },
	{
		name: 'CryptoGreen',
		pitch: 'Eco-friendly cryptocurrency mining solutions.',
	},
	{ name: 'NeuroLearn', pitch: 'AI-powered personalized learning pathways.' },
	{
		name: 'SkyFarm',
		pitch: 'Vertical farming solutions for urban environments.',
	},
	{ name: 'BioHack', pitch: 'DIY genetic engineering kits for hobbyists.' },
	{ name: 'TeleTouch', pitch: 'Haptic feedback gloves for virtual reality.' },
	{ name: 'EcoFuel', pitch: 'Algae-based biofuel production systems.' },
	{ name: 'MindMap', pitch: 'Brain activity visualization for mental health.' },
	{ name: 'RoboChef', pitch: 'AI-powered robotic kitchen assistant.' },
	{ name: 'SolarSkin', pitch: 'Flexible solar panels for wearable tech.' },
	{
		name: 'AquaPrint',
		pitch: '3D printing with water-based, biodegradable materials.',
	},
	{
		name: 'QuantumKey',
		pitch: 'Quantum encryption for ultimate data security.',
	},
	{
		name: 'BioMimicry',
		pitch: 'Nature-inspired solutions for engineering problems.',
	},
	{ name: 'NanoHeal', pitch: 'Nanobot-assisted wound healing technology.' },
	{
		name: 'AirText',
		pitch: 'Gesture-based aerial holographic typing interface.',
	},
	{ name: 'EcoPackage', pitch: 'Self-dissolving packaging materials.' },
	{ name: 'NeuroLink', pitch: 'Brain-to-brain communication device.' },
	{ name: 'HoloAd', pitch: 'Personalized holographic advertising platform.' },
	{
		name: 'GeneEdit',
		pitch: 'CRISPR-based genetic disorder treatment service.',
	},
	{
		name: 'AstroMine',
		pitch: 'Asteroid mining equipment for space exploration.',
	},
	{
		name: 'EcoFabric',
		pitch: 'Carbon-negative textiles from atmospheric CO2.',
	},
	{ name: 'MindWave', pitch: 'Thought-controlled smart home systems.' },
	{
		name: 'BioLight',
		pitch: 'Bioluminescent plants for sustainable street lighting.',
	},
	{
		name: 'CloudFood',
		pitch: 'Lab-grown meat production for sustainable protein.',
	},
	{
		name: 'VirtualTaste',
		pitch: 'Digital taste simulation for virtual dining experiences.',
	},
	{ name: 'EcoBot', pitch: 'AI-powered personal sustainability assistant.' },
	{ name: 'QuantumSim', pitch: 'Quantum computing simulator for developers.' },
	{
		name: 'NeuroPaint',
		pitch: 'Brain-computer interface for digital art creation.',
	},
	{
		name: 'HydroHarvest',
		pitch: 'Water harvesting technology for arid regions.',
	},
	{
		name: 'BioSync',
		pitch: 'Symbiotic wearable tech for health optimization.',
	},
	{
		name: 'SoundSculpt',
		pitch: 'AI-generated music based on emotional input.',
	},
	{
		name: 'HoloTeach',
		pitch: 'Augmented reality educational content platform.',
	},
	{
		name: 'EcoScan',
		pitch: 'Handheld device for detecting harmful chemicals.',
	},
	{ name: 'QuantumNet', pitch: 'Quantum internet infrastructure solutions.' },
	{ name: 'NanoFarm', pitch: 'Nanotech-enhanced vertical farming systems.' },
	{
		name: 'BrainBoost',
		pitch: 'Cognitive enhancement through targeted neurostimulation.',
	},
	{ name: 'EcoFashion', pitch: 'AI stylist for sustainable fashion choices.' },
	{
		name: 'SolarRoad',
		pitch: 'Solar panel road surfaces for energy generation.',
	},
	{ name: 'AquaLens', pitch: 'Underwater augmented reality diving goggles.' },
	{
		name: 'NeuroFit',
		pitch: 'Brain-training exercises for cognitive improvement.',
	},
	{ name: 'BioPlastic', pitch: 'Fully biodegradable plastic alternatives.' },
	{
		name: 'DreamTech',
		pitch: 'Technology for recording and replaying dreams.',
	},
	{
		name: 'EcoTravel',
		pitch: 'Carbon-neutral transportation booking platform.',
	},
	{ name: 'GenomeGuard', pitch: 'Personal genomic data protection service.' },
	{ name: 'RoboPet', pitch: 'AI-powered robotic companions for children.' },
	{
		name: 'AstroGrow',
		pitch: 'Plants optimized for extraterrestrial agriculture.',
	},
	{ name: 'MindMeld', pitch: 'Collaborative virtual reality workspaces.' },
	{
		name: 'EcoEnergy',
		pitch: 'Decentralized renewable energy trading platform.',
	},
	{
		name: 'NeuroLearn',
		pitch: 'Adaptive learning software using brainwave data.',
	},
	{ name: 'HoloFit', pitch: 'Holographic personal trainer and fitness coach.' },
]

export const CREATE_BUTTON = [
	'Launch',
	'Ignite',
	'Kickstart',
	'Unleash',
	'Propel',
	'Initiate',
	'Spark',
	'Commence',
	'Debut',
	'Unveil',
	'Introduce',
	'Activate',
	'Jumpstart',
	'Catalyze',
	'Trigger',
	'Inaugurate',
	'Pioneer',
	'Spearhead',
	'Rollout',
	'Embark',
]

export const PAGEFONTS = [
	'ABeeZee',
	'Abel',
	'Abril Fatface',
	'Acme',
	'Actor',
	'Advent Pro',
	'Alegreya',
	'Alegreya Sans',
	'Alfa Slab One',
	'Alice',
	'Almarai',
	'Amatic SC',
	'Amiri',
	'Amaranth',
	'Anton',
	'Antic Slab',
	'Archivo',
	'Archivo Black',
	'Archivo Narrow',
	'Architects Daughter',
	'Arimo',
	'Armata',
	'Arapey',
	'Arvo',
	'Asap',
	'Asap Condensed',
	'Assistant',
	'Audiowide',
	'Bangers',
	'Barlow',
	'Barlow Condensed',
	'Barlow Semi Condensed',
	'Bebas Neue',
	'BenchNine',
	'Bitter',
	'Black Ops One',
	'Bree Serif',
	'Cabin',
	'Cabin Condensed',
	'Cairo',
	'Candal',
	'Cantarell',
	'Cardo',
	'Catamaran',
	'Caveat',
	'Chakra Petch',
	'Changa',
	'Changa One',
	'Chewy',
	'Chivo',
	'Cinzel',
	'Coming Soon',
	'Comfortaa',
	'Concert One',
	'Cookie',
	'Cormorant Garamond',
	'Courgette',
	'Covered By Your Grace',
	'Crete Round',
	'Crimson Text',
	'Cuprum',
	'Dancing Script',
	'Default',
	'Didact Gothic',
	'DM Sans',
	'DM Serif Display',
	'Domine',
	'Dosis',
	'EB Garamond',
	'Economica',
	'Exo',
	'Exo 2',
	'Fira Sans',
	'Fira Sans Condensed',
	'Fira Sans Extra Condensed',
	'Fjalla One',
	'Frank Ruhl Libre',
	'Francois One',
	'Gloria Hallelujah',
	'Great Vibes',
	'Gudea',
	'Hammersmith One',
	'Handlee',
	'Heebo',
	'Hind',
	'Hind Madurai',
	'Hind Siliguri',
	'IBM Plex Mono',
	'IBM Plex Sans',
	'IBM Plex Serif',
	'Inconsolata',
	'Indie Flower',
	'Inter',
	'Istok Web',
	'Josefin Sans',
	'Josefin Slab',
	'Jost',
	'Jura',
	'Kalam',
	'Kanit',
	'Karla',
	'Kaushan Script',
	'Khand',
	'Kreon',
	'Lato',
	'Libre Baskerville',
	'Libre Franklin',
	'Lilita One',
	'Lobster',
	'Lobster Two',
	'Lora',
	'Luckiest Guy',
	'M PLUS 1p',
	'M PLUS Rounded 1c',
	'Manrope',
	'Marck Script',
	'Martel',
	'Maven Pro',
	'Merriweather',
	'Merriweather Sans',
	'Monda',
	'Montserrat',
	'Montserrat Alternates',
	'Mukta',
	'Mulish',
	'Nanum Gothic',
	'Nanum Myeongjo',
	'Neucha',
	'Neuton',
	'News Cycle',
	'Nobile',
	'Noticia Text',
	'Noto Sans',
	'Noto Serif',
	'Nunito',
	'Nunito Sans',
	'Old Standard TT',
	'Oleo Script',
	'Open Sans',
	'Orbitron',
	'Oswald',
	'Outfit',
	'Overpass',
	'Oxygen',
	'Pacifico',
	'Padauk',
	'Parisienne',
	'Passion One',
	'Patrick Hand',
	'Patua One',
	'Paytone One',
	'Permanent Marker',
	'Philosopher',
	'Play',
	'Playfair Display',
	'Playfair Display SC',
	'Playball',
	'Plus Jakarta Sans',
	'Poiret One',
	'Pontano Sans',
	'Poppins',
	'Prata',
	'Press Start 2P',
	'Prompt',
	'PT Sans',
	'PT Sans Caption',
	'PT Sans Narrow',
	'PT Serif',
	'Public Sans',
	'Quattrocento',
	'Quattrocento Sans',
	'Questrial',
	'Quicksand',
	'Rajdhani',
	'Raleway',
	'Red Hat Display',
	'Righteous',
	'Roboto',
	'Roboto Condensed',
	'Roboto Mono',
	'Roboto Slab',
	'Rock Salt',
	'Rokkitt',
	'Ropa Sans',
	'Rubik',
	'Ruda',
	'Russo One',
	'Sacramento',
	'Saira Condensed',
	'Sanchez',
	'Sarabun',
	'Satisfy',
	'Secular One',
	'Shadows Into Light',
	'Sigmar One',
	'Signika',
	'Signika Negative',
	'Source Code Pro',
	'Source Sans 3',
	'Space Grotesk',
	'Space Mono',
	'Special Elite',
	'Spectral',
	'Squada One',
	'Staatliches',
	'Tangerine',
	'Teko',
	'Tinos',
	'Titillium Web',
	'Ubuntu',
	'Ubuntu Condensed',
	'Ubuntu Mono',
	'Ultra',
	'Varela',
	'Varela Round',
	'Viga',
	'Vidaloka',
	'Vollkorn',
	'Volkhov',
	'Work Sans',
	'Yanone Kaffeesatz',
	'Yantramanav',
	'Yellowtail',
	'Zilla Slab',
]

export const EMAILFONTS = [
	'Arial',
	'Arial Black',
	'Calibri',
	'Century Gothic',
	'Geneva',
	'Lucida',
	'Courier',
	'Courier New',
	'Georgia',
	'Times New Roman',
	'Garamond',
	'Palatino',
	'Tahoma',
	'Trebuchet MS',
	'Verdana',
]

export const PAGE_TYPES = {
	SIGNUP: 'signup_page',
	SUBSCRIBER: 'subscriber_page',
	REFERRAL: 'referral_page',
	SUCCESS: 'success_page',
	TEMPLATE: 'template',
}

export const EMAIL_TYPES = {
	VERIFICATION: 'verification_email',
	INVITATION: 'invitation_email',
	REDEEMED: 'redeemed_email',
	GENERIC: 'email',
	CAMPAIGN: 'campaign_email',
	TEMPLATE: 'template',
}

export const PROJECT_BASE_COLOR = '#000000'

export const TEST_SUB = {
	shortId: 'test_sub_id',
	firstName: 'Maxime',
	lastName: 'Junique',
}

export const BASE_THEME = {
	name: 'Base Theme',
	color: '#000000',
	backgroundColor: '#FFFFFF',
	borderColor: '#F4F4F4',
	accentColor: '#000000',
	buttonTextColor: '#FFFFFF',
	headingColor: '#000000',
	paragraphColor: '#000000',
	inputTextColor: '#000000',
	headingFont: 'Default',
	paragraphFont: 'Default',
	backgroundInputColor: '#FFFFFF',
	radius: 12,
}

export const BASE_VARIABLES = {
	SUB: [
		{
			name: 'First name',
			id: 'sub.firstName',
		},
		{
			name: 'Position',
			id: 'sub.position',
		},
		{
			name: 'Referral link',
			id: 'sub.referralLink',
		},
		{
			name: 'Subscriber link',
			id: 'sub.subscriberLink',
		},
		{
			name: 'Verification link',
			id: 'sub.verificationLink',
		},
		{
			name: 'Jump 1 place',
			id: 'sub.jumpOne',
		},
		{
			name: 'Jump everyone',
			id: 'sub.jumpAll',
		},
	],
	LIST: [
		{
			name: 'Project name',
			id: 'list.name',
		},
		{
			name: 'Project URL',
			id: 'list.projectLink',
		},
		{
			name: 'Last 24h count',
			id: 'list.last24hCount',
		},
		{
			name: 'Total count',
			id: 'list.totalCount',
		},
		{
			name: 'Next position',
			id: 'list.nextPosition',
		},
	],
	USER: [
		{
			name: 'Username',
			id: 'user.username',
		},
		{
			name: 'Email',
			id: 'user.email',
		},
		{
			name: 'User limit',
			id: 'user.limit',
		},
		{
			name: 'User plan',
			id: 'user.plan',
		},
		{
			name: 'User name',
			id: 'user.name',
		},
	],
}

export const CUSTOMIZER_MAX_WIDTH = 600

export const TRUSTED_DOMAINS = [
	'https://wt.ls',
	'http://localhost:3000',
	'https://wtls-pg-st.fly.dev',
]

export const F_HANDLES = [
	'_domainkey',
	'abuse',
	'admin',
	'administrator',
	'administration',
	'autoconfig',
	'autodiscover',
	'broadcasthost',
	'cp',
	'cpanel',
	'domain',
	'editor',
	'guest',
	'host',
	'hostmaster',
	'info',
	'seo',
	'keybase.txt',
	'localdomain',
	'localhost',
	'master',
	'mail',
	'mail0',
	'mail1',
	'mail2',
	'mail3',
	'mail4',
	'mail5',
	'mail6',
	'mail7',
	'mail8',
	'mail9',
	'mailerdaemon',
	'mailer-daemon',
	'me',
	'embed',
	'member',
	'members',
	'moderator',
	'nobody',
	'modal',
	'owner',
	'postmaster',
	'poweruser',
	'private',
	'public',
	'root',
	'rootuser',
	'super',
	'superuser',
	'sysadmin',
	'user',
	'users',
	'usenet',
	'webmaster',
	'www-data',
	'.htaccess',
	'.htpasswd',
	'.git',
	'.well-known',
	'400',
	'401',
	'403',
	'404',
	'405',
	'406',
	'407',
	'408',
	'409',
	'410',
	'411',
	'412',
	'413',
	'414',
	'415',
	'416',
	'417',
	'421',
	'422',
	'423',
	'424',
	'426',
	'428',
	'429',
	'431',
	'500',
	'501',
	'502',
	'503',
	'504',
	'505',
	'506',
	'507',
	'508',
	'509',
	'510',
	'511',
	'aes128-ctr',
	'aes192-ctr',
	'aes256-ctr',
	'aes128-gcm',
	'aes256-gcm',
	'ajax',
	'alpha',
	'amp',
	'asc',
	'assets',
	'atom',
	'beta',
	'captcha',
	'cdn',
	'cgi',
	'cgi-bin',
	'chacha20-poly1305',
	'client',
	'com',
	'count',
	'curve25519-sha256',
	'crossdomain.xml',
	'css',
	'db',
	'debug',
	'desc',
	'dev',
	'diffie-hellman-group-exchange-sha256',
	'diffie-hellman-group14-sha1',
	'dns',
	'dns0',
	'dns1',
	'dns2',
	'dns3',
	'dns4',
	'ecdh-sha2-nistp256',
	'ecdh-sha2-nistp384',
	'ecdh-sha2-nistp521',
	'error',
	'errors',
	'exception',
	'false',
	'favicon.ico',
	'filter',
	'ftp',
	'get',
	'git',
	'hmac-sha',
	'hmac-sha1',
	'hmac-sha1-etm',
	'hmac-sha2-256',
	'hmac-sha2-512',
	'hmac-sha2-256-etm',
	'hmac-sha2-512-etm',
	'http',
	'httpd',
	'https',
	'humans.txt',
	'icons',
	'imap',
	'img',
	'is',
	'isatap',
	'it',
	'js',
	'json',
	'graphql',
	'limit',
	'live',
	'map',
	'mis',
	'mx',
	'mx1',
	'net',
	'network',
	'noc',
	'none',
	'nil',
	'ns',
	'ns0',
	'ns1',
	'ns2',
	'ns3',
	'ns4',
	'ns5',
	'ns6',
	'ns7',
	'ns8',
	'ns9',
	'null',
	'owa',
	'post',
	'prod',
	'production',
	'robots.txt',
	'rsa-sha2-512',
	'rsa-sha2-2',
	'rss',
	'script',
	'source',
	'sitemap',
	'smtp',
	'sql',
	'ssh',
	'ssh-rsa',
	'ssl',
	'ssladmin',
	'ssladministrator',
	'sslwebmaster',
	'stage',
	'staging',
	'static',
	'style',
	'styles',
	'stylesheet',
	'stylesheets',
	'subdomain',
	'sudo',
	'telnet',
	'test',
	'true',
	'umac-64',
	'umac-128',
	'umac-64-etm',
	'umac-128-etm',
	'undefined',
	'uucp',
	'var',
	'void',
	'vpn',
	'webmail',
	'wpad',
	'www',
	'www1',
	'www2',
	'www3',
	'www4',
	'zlib',
	'ad',
	'ads',
	'api',
	'auth',
	'authentication',
	'authorize',
	'avatar',
	'banner',
	'banners',
	'cache',
	'cas',
	'chart',
	'config',
	'cookies',
	'cms',
	'draft',
	'email',
	'emails',
	'head',
	'header',
	'htpasswd',
	'm',
	'metrics',
	'mobile',
	'noreply',
	'no-reply',
	'oauth',
	'oauth2',
	'online',
	'openid',
	'passwd',
	'password',
	'pixel',
	'pop',
	'pop3',
	'postfix',
	'redirect',
	'request',
	'response',
	'sdk',
	'shop',
	'secure',
	'security',
	'session',
	'sessions',
	'sysadmin',
	'system',
	'tablet',
	'trial',
	'username',
	'yourname',
	'yourusername',
	'advertise',
	'advertising',
	'ads.txt',
	'affiliate',
	'affiliates',
	'app-ads.txt',
	'billing',
	'billings',
	'business',
	'campaign',
	'contest',
	'cart',
	'checkout',
	'deals',
	'hosting',
	'investors',
	'invoice',
	'license',
	'licensing',
	'marketing',
	'marketplace',
	'offer',
	'offers',
	'order',
	'orders',
	'pay',
	'payment',
	'payments',
	'paypal',
	'partners',
	'promo',
	'premium',
	'sales',
	'store',
	'about',
	'about-us',
	'access',
	'alert',
	'alerts',
	'analytics',
	'app',
	'apps',
	'account',
	'accounts',
	'backup',
	'bbs',
	'board',
	'bookmark',
	'bookmarks',
	'blog',
	'blogs',
	'calendar',
	'careers',
	'category',
	'categories',
	'chat',
	'channel',
	'channels',
	'cloud',
	'comment',
	'comments',
	'community',
	'contact',
	'copyright',
	'customer',
	'customers',
	'dashboard',
	'developer',
	'developers',
	'docs',
	'documentation',
	'download',
	'downloads',
	'enterprise',
	'event',
	'events',
	'example',
	'explore',
	'extensions',
	'family',
	'faq',
	'faqs',
	'features',
	'feed',
	'feedback',
	'feeds',
	'file',
	'files',
	'fonts',
	'form',
	'forms',
	'forum',
	'forums',
	'friend',
	'friends',
	'follower',
	'followers',
	'following',
	'forgot',
	'forgotpassword',
	'forgot-password',
	'group',
	'groups',
	'guidelines',
	'guides',
	'help',
	'home',
	'images',
	'invitations',
	'invites',
	'issues',
	'jobs',
	'legal',
	'local',
	'lost-password',
	'media',
	'message',
	'messages',
	'more',
	'my',
	'new',
	'news',
	'next',
	'newsletter',
	'newsletters',
	'notification',
	'notifications',
	'overview',
	'page',
	'pages',
	'photo',
	'photos',
	'plans',
	'plugins',
	'policy',
	'policies',
	'popular',
	'portal',
	'portfolio',
	'press',
	'pricing',
	'ressources',
	'privacy',
	'privacy-policy',
	'preferences',
	'previous',
	'product',
	'profile',
	'profiles',
	'project',
	'projects',
	'quota',
	'refund',
	'refunds',
	'registration',
	'replies',
	'reply',
	'request-password',
	'reset-password',
	'return',
	'returns',
	'reviews',
	'rules',
	'settings',
	'setup',
	'services',
	'site',
	'sites',
	'stat',
	'stats',
	'status',
	'statistics',
	'survey',
	'tag',
	'tags',
	'team',
	'terms',
	'terms-of-use',
	'testimonials',
	'theme',
	'themes',
	'today',
	'tools',
	'topic',
	'topics',
	'tour',
	'training',
	'translations',
	'trending',
	'widget',
	'widgets',
	'you',
	'video',
	'website',
	'wiki',
	'add',
	'buy',
	'action',
	'change',
	'clear',
	'close',
	'compare',
	'compose',
	'connect',
	'copy',
	'create',
	'customize',
	'delete',
	'destroy',
	'disconnect',
	'discuss',
	'downvote',
	'drop',
	'edit',
	'exit',
	'export',
	'follow',
	'go',
	'hide',
	'import',
	'index',
	'insert',
	'invite',
	'join',
	'learn',
	'like',
	'load',
	'lock',
	'login',
	'logout',
	'modify',
	'print',
	'internal',
	'purchase',
	'put',
	'reduce',
	'register',
	'remove',
	'report',
	'reset',
	'review',
	'save',
	'search',
	'select',
	'share',
	'shift',
	'signin',
	'signup',
	'sort',
	'subscribe',
	'subscriber',
	'subscribers',
	'support',
	'sync',
	'translate',
	'unfollow',
	'update',
	'upgrade',
	'unlike',
	'unsubscribe',
	'verify',
	'view',
	'vote',
	'write',
]

export const FORM_ERRORS = {
	FIELD: {
		UNIQUE: 'Must be unique',
		REQUIRED: 'Required',
		INVALID: 'Invalid',
	},
	GENERAL: {
		UNIQUE: 'Some fields already exist',
		WRONG: 'Something went wrong',
		REQUIRED: 'Required',
		INVALID: 'Invalid',
	},
}
export interface PUBLIC_FORM {
	errors: {
		fields: {
			[key: string]: string
		}
		general: string
	}
}
